import { cn } from '@/lib/utils'

type ArticleVideoProps = {
  src: string
  poster: string
  captions: string
  /** Its accessible name. */
  label: string
  /** 16:9 at the column's width, for the film and clips cut from it. The feature clips are 4:5. */
  wide?: boolean
  className?: string
}

/** An article's video, narrated, with its captions on by default since it starts muted on a phone. */
export function ArticleVideo({ src, poster, captions, label, wide = false, className }: ArticleVideoProps) {
  return (
    <video
      className={cn('block w-full rounded-2xl bg-neutral-2', wide ? 'aspect-video' : 'mx-auto aspect-[4/5] max-w-sm', className)}
      src={src}
      poster={poster}
      controls
      playsInline
      preload="metadata"
      aria-label={label}
    >
      <track kind="captions" src={captions} srcLang="en" label="English" default />
    </video>
  )
}
